/**
 * QRMaps Design System - Z-Index Tokens
 *
 * Layering system to manage stacking contexts
 * Extracted from current usage in MainMap.js and components
 */

export const zIndex = {
  // Base layer
  base: 0,

  // Map layers (from MainMap.js layer definitions)
  mapTiles: 0,
  mapTilesVPS: 1,
  mapGeoJson: 5,
  mapTours: 15,
  mapShade: 40,
  mapEditRect: 50,
  mapBuildings: 60,
  mapRiverKm: 65,
  mapTempPoint: 70,
  mapMarkers: 70,
  mapABMarkers: 71,

  // UI layers
  dropdown: 10,
  overlay: 40,
  modal: 50,
  sidebar: 100,
  sidebarControls: 110, // Drag handle and close button
  toast: 60,
  tooltip: 70,

  // Map controls (from geolocation button)
  mapControls: 1000,

  // Top-most layers
  notification: 9998,
  emergency: 9999,
};